/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { unproxiedMcpGetServer } from "../funcs/unproxiedMcpGetServer.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { UnproxiedMcpServer } from "../models/components/unproxiedmcpserver.js";
import {
  GetUnproxiedMcpServerRequest,
  GetUnproxiedMcpServerSecurity,
} from "../models/operations/getunproxiedmcpserver.js";
import { unwrapAsync } from "../types/fp.js";
export type GetUnproxiedMcpServerQueryData = UnproxiedMcpServer;

export function prefetchGetUnproxiedMcpServer(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetUnproxiedMcpServerRequest | undefined,
  security?: GetUnproxiedMcpServerSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetUnproxiedMcpServerQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetUnproxiedMcpServerQuery(
  client$: GramCore,
  request?: GetUnproxiedMcpServerRequest | undefined,
  security?: GetUnproxiedMcpServerSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetUnproxiedMcpServerQueryData>;
} {
  return {
    queryKey: queryKeyGetUnproxiedMcpServer({
      id: request?.id,
      slug: request?.slug,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function getUnproxiedMcpServerQueryFn(
      ctx,
    ): Promise<GetUnproxiedMcpServerQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(unproxiedMcpGetServer(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetUnproxiedMcpServer(
  parameters: {
    id?: string | undefined;
    slug?: string | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "unproxiedMcp", "getServer", parameters];
}
